/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";
import { useState, useEffect } from "@wordpress/element";
import { isEmpty } from "lodash";

function App() {
	const [active, setActive] = useState(false);
	const [contentHeight, setContentHeight] = useState(0);

	useEffect(() => {
		const iframe = document.querySelector(".block-editor-page iframe");
		const rootContainer = document.querySelector(".editor-styles-wrapper");

		if (isEmpty(iframe)) {
			setContentHeight(rootContainer?.offsetHeight);
		} else {
			setContentHeight(iframe?.contentWindow?.document?.body?.offsetHeight);
		}

		if (active) {
			iframe?.setAttribute("scrolling", "no");
		} else {
			iframe?.setAttribute("scrolling", "yes");
		}
	}, [active]);

	return (
		<div>
			<Button
				style={{ marginRight: 5 }}
				icon={active ? "editor-contract" : "editor-expand"}
				iconSize="32"
				onClick={() => setActive(!active)}
			></Button>
			{active && (
				<style>
					{`
                  .edit-post-visual-editor__content-area .is-desktop-preview {
                    background: #1e1e1e !important;
                  }

                  .edit-post-visual-editor__content-area .is-desktop-preview iframe {
                     transform: scale(0.45) !important;
                     height: ${contentHeight}px !important;
                     pointer-events: none;
                     user-select: none;
					 margin-top: 50px;
					 margin-bottom: -${contentHeight * 0.45}px;
					 transform-origin: top center;
                  }

				  .is-desktop-preview .editor-styles-wrapper {
					 transform: scale(0.45) !important;
					 pointer-events: none;
                     user-select: none;
					 margin-top: 50px;
					 transform-origin: top center;
					 margin-bottom: -${contentHeight * 0.45}px;
				  }
                `}
				</style>
			)}
		</div>
	);
}

export default App;
